export default "__VITE_PUBLIC_ASSET__6a20c392__"